import React from 'react';
export const CTAButton = () => {
  return <a href="https://trynymera.com/products/nymera-sleep-strips" target="_blank" rel="noopener noreferrer" data-id="element-215">
      <button className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-8 rounded-lg text-lg shadow-lg transition duration-300 transform hover:scale-105" aria-label="Claim my 50% savings now" data-id="element-216">
        CLAIM MY 50% SAVINGS NOW
      </button>
    </a>;
};